import { Search } from 'lucide-react'
import { Card } from '@/shared/components/ui/card'
import { Input } from '@/shared/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'
import { TIPOS_CONTACTO } from '@/modules/bd-unificada/types/contacto'

interface ContactosFiltersProps {
  search: string
  onSearchChange: (value: string) => void
  tipo?: string
  onTipoChange: (value?: string) => void
  pais?: string
  onPaisChange: (value?: string) => void
  especialidad?: string
  onEspecialidadChange: (value?: string) => void
  especialidades?: string[]
  ciudad?: string
  onCiudadChange: (value?: string) => void
  provincia?: string
  onProvinciaChange: (value?: string) => void
}

export function ContactosFilters({
  search,
  onSearchChange,
  tipo,
  onTipoChange,
  pais,
  onPaisChange,
  especialidad,
  onEspecialidadChange,
  especialidades = [],
  ciudad,
  onCiudadChange,
  provincia,
  onProvinciaChange,
}: ContactosFiltersProps) {
  return (
    <Card className="p-4 border border-gray-300 dark:border-gray-700">
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
        <div className="relative flex-1 sm:min-w-[240px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            className="pl-9"
            placeholder="Buscar por cédula, email, teléfono o nombre (mín. 2 caracteres)…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        <Select
          value={tipo ?? 'all'}
          onValueChange={(v) => onTipoChange(v === 'all' ? undefined : v)}
        >
          <SelectTrigger className="w-full sm:w-[200px]">
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los tipos</SelectItem>
            {TIPOS_CONTACTO.map((t) => (
              <SelectItem key={t.value} value={t.value}>
                {t.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select
          value={especialidad ?? 'all'}
          onValueChange={(v) => onEspecialidadChange(v === 'all' ? undefined : v)}
        >
          <SelectTrigger className="w-full sm:w-[200px]">
            <SelectValue placeholder="Especialidad" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas las especialidades</SelectItem>
            {especialidades.map((esp) => (
              <SelectItem key={esp} value={esp}>
                {esp}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Input
          className="w-full sm:w-[200px]"
          placeholder="País"
          value={pais ?? ''}
          onChange={(e) => onPaisChange(e.target.value || undefined)}
        />

        <Input
          className="w-full sm:w-[200px]"
          placeholder="Ciudad"
          value={ciudad ?? ''}
          onChange={(e) => onCiudadChange(e.target.value || undefined)}
        />

        <Input
          className="w-full sm:w-[200px]"
          placeholder="Provincia"
          value={provincia ?? ''}
          onChange={(e) => onProvinciaChange(e.target.value || undefined)}
        />
      </div>
    </Card>
  )
}
